"use strict";
jQuery(function ($) {
  $(document).ready(function () { 
    $('#weglot-switcher-1 > .wg-drop.country-selector ul').addClass("background-off-switcher");
    (function responsiveMenu() {
      const menuMovil = document.querySelector(".menu-responsive");
      const burguerButton = document.querySelector(".box-burguer");
      const equisMenu = document.querySelector(".container-x");
      $(burguerButton).click(() => {
        menuMovil.style.animation = "menuIn .5s forwards";
      });
      $(equisMenu).click(() => {
        menuMovil.style.animation = "menuOut .5s forwards";
      });
      return responsiveMenu;
    })();

    (function scrollNav() {
      const onScrollMenu = (e) => {
        const newShowMenu = window.scrollY > 101;
        const $menuScroll = document.querySelector(".site-header");
        const buttonsMainMenu = document.querySelectorAll(".button-nav-mina");
        const buttonCart = document.querySelectorAll(".menu-item-r");
        const logoBlack = $(".logoBlack");
        const logoWhite = $(".logoWhite");
        const iconLogin = $(".icon-login-c");
        const iconSearch = $(".icon-search-c");
        const iconBurguer = $(".icon-burguer");
        const iconCart = $(".icon-cart-responsive");
        if (newShowMenu) {
          $menuScroll.classList.add("active-menu_stiky");
          $(buttonsMainMenu).addClass("color-item-scroll");
          $(buttonCart).addClass("color-item-scroll");
          logoBlack.addClass("onlogoBlack");
          logoWhite.addClass("offlogoWhite");
          iconBurguer.addClass("iconBurguer_Black");
          iconCart.addClass("cart_black");
          iconLogin.addClass("cart_black");
          iconSearch.addClass("cart_black");
          $('#weglot-switcher-1 > .country-selector a').attr('style', 'color: #000!important');
          $('#weglot-switcher-1 > .wg-drop.country-selector .wgcurrent').addClass("switcher-on-menu");
          $('#weglot-switcher-1 > .wg-drop.country-selector ul').removeClass("background-off-switcher");
          $('#weglot-switcher-1 > .wg-drop.country-selector ul').addClass("background-on-switcher");
        } else {
          $menuScroll.classList.remove("active-menu_stiky");
          $(buttonsMainMenu).removeClass("color-item-scroll");
          $(buttonCart).removeClass("color-item-scroll");
          logoBlack.removeClass("onlogoBlack");
          logoWhite.removeClass("offlogoWhite");
          iconBurguer.removeClass("iconBurguer_Black");
          iconCart.removeClass("cart_black");
          iconSearch.removeClass("cart_black");
          iconLogin.removeClass("cart_black");
          $('#weglot-switcher-1 > .country-selector a').attr('style', 'color: #FFF!important');
          $('#weglot-switcher-1 > .wg-drop.country-selector .wgcurrent').removeClass("switcher-on-menu");
          $('#weglot-switcher-1 > .wg-drop.country-selector ul').removeClass("background-on-switcher");
          $('#weglot-switcher-1 > .wg-drop.country-selector ul').addClass("background-off-switcher");
        }
      };
      document.addEventListener("scroll", onScrollMenu);
      return scrollNav;
    })();

    function dropDrop(menu) {
      const buttonsMainMenu = document.querySelectorAll(".button-nav-mina");
      const buttonCart = document.querySelectorAll(".menu-item-r");
      const logoContainer = document.querySelector(".logoWhite");
      const logoBlack = document.querySelector(".logoBlack")
      const cartLogo = document.querySelectorAll(".icon-cart-responsive");
      let $overlayDrawer = $(".overlay-menu");
      $(menu).each(function () {
        $(this).on({
          mouseenter: function (e) {
            let dataModalID = $(this).attr("id_menu_button");
            let modalDrop = $(`.fixed-modal-sous[id=${dataModalID}]`);
            $(".fixed-modal-sous").css("display", "none");
            $(modalDrop).css({
              display: "block",
              animation: "modalesMenuIn .4s forwards",
            });
            if(isIpadOS) {
              $("body").addClass("noscroll");
            }
            $(buttonsMainMenu).addClass("drop-in_color");
            $(buttonCart).addClass("drop-in_color");
            $(cartLogo).addClass("drop-in_color");
            $(logoContainer).addClass("offlogoWhite-drop");
            $(logoBlack).addClass("offlogoBlack-drop");
            $overlayDrawer.addClass("overlayActive");
          },
          mouseleave: function () {
            let dataModalID = $(this).attr("id_menu_button");
            let modalDrop = $(`.fixed-modal-sous[id=${dataModalID}]`);
            if(isIpadOS) {
              $("body").removeClass("noscroll");
            }
            modalDrop.hover(
              () => {
                return null;
              },
              () => {
                $(modalDrop).css("animation", "modalesMenuOut .5s forwards");
                $(buttonsMainMenu).removeClass("drop-in_color");
                $(buttonCart).removeClass("drop-in_color");
                $(logoContainer).removeClass("offlogoWhite-drop");
                $(cartLogo).removeClass("drop-in_color");
                $(logoBlack).removeClass("offlogoBlack-drop");
                $overlayDrawer.removeClass("overlayActive");
              }
            );
          },
        });
      });
    }

    function dropDropResponsive(menuResponsive, closeModale) {
      const cartLogo = document.querySelectorAll(".icon-cart-responsive");
      $(menuResponsive).each(function () {
        $(this).on({
          click: function () {
            let dataModalID = $(this).attr("id_menu_button");
            $(".fixed-modal-sous").css("display", "block");
            let modalDrop = $(`.fixed-modal-sous[id=${dataModalID}]`);
            $(modalDrop).css("animation", "modalesMenuIn .4s forwards");
            $(cartLogo).css("color", "#121212");
          },
        });
      });
      $(closeModale).each(function () {
        $(this).on({
          click: function () {
            let dataModalID = $(this).attr("close_id-drop");
            let modalDrop = $(`.fixed-modal-sous[id=${dataModalID}]`);
            $(modalDrop).css("animation", "modalesMenuOut .4s forwards");
            $(cartLogo).css("color", "white");
          },
        });
      });
    }

    (function activeVetements() {
      dropDrop(".menu-desktop li button");
      dropDropResponsive(
        ".menu-responsive li button",
        ".close-container-drop-movil"
      );
      return activeVetements;
    })();


    //cart init
    cartItems();


    // Function to show search products
    (function searchDrawer() {
      
      const $buttonSearch = $(".drawer-button");
      const $drawerModal = $(".drawer");
      const $buttonCloseSearch = $(".search-bar__close");
      $buttonSearch.click(()=> {
        
        document.body.classList.add("js-drawer-open-top");
        $drawerModal.addClass(".js-drawer-open-top");
      });
      $buttonCloseSearch.click(()=>{
        document.body.classList.remove("js-drawer-open-top");
        $drawerModal.removeClass(".js-drawer-open-top");
      });
    }());

    (function closeModalLivrason() {
      const modalLivrason = document.querySelector(".livrason_bar");
      const modalMenu = document.querySelectorAll(".fixed-modal-sous");
      if(!modalLivrason) {
        for (let v of modalMenu) {
          v.style.padding = "0 55px 0 55px";
        }
      }
      const $closeBar = $(".close-modal_calcule");
      $closeBar.click(()=>{
        $(".livrason_bar").addClass("close-display");
        $(".close-modal_calcule").addClass("close-display");
        $(".fixed-modal-sous").css("padding", "0 55px 0 55px");
      });
    })();

    function isIpadOS() {
      return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
    }

    console.log("isIpadOS" + isIpadOS())



    // (async function APIReviews () {
    //   let url = new URL("https://judge.me/api/v1/reviews/");
    //   const params = { "api_token": "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", "shop_domain": "minastormdev.myshopify.com" }
    //   const linkQuery = "https://judge.me/api/v1/reviews/api_key/588906e1272b1ce816a0171e0421cf10/shop_domain/minastormdev.myshopify.com";
    //   Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    //   const dataRequest = {
    //     method: 'GET'
    //   };
    //   await fetch(url, dataRequest)
    //     .then((data) => {
    //       return data.json();
    //     })
    //     .then((data) => {
    //       console.log(data);
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    //   })();

    // (function bundlesPack() {
    //   $(window).load(()=>{
    //     setTimeout(()=>{

    //       function changeTitle(){
    //           $(".tdf_vertical_title").each(function() {
    //           let $textTitle = $(this).attr("title");
    //           console.log($textTitle);
    //           $(this).html(`<div class="product-card__title-mina"><div>${$textTitle.split(' - ')[0]}</div><span class='color-sswatch'>${$textTitle.split(' - ')[1]}</span></div>`);
    //         });
    //       }

    //       function optionChange() {
    //         $(".tdf_select_input option").each(function() {
    //           let $foo = $(this).text();
    //           $(this).text(`${$foo.split(" ")[1]}`);
    //           // console.log($foo.split(" ")[1]);
    //         });
    //       }

    //       $(".tdf_select_input").each(function() {
    //         $(this).change(()=>{
    //           changeTitle();
    //         });
    //       });

    //       changeTitle();
    //       optionChange();
    //     }, 2000);
    //   });
    // }());


    // // function to valider password confirm
    // $('form#create_customer').submit(function(e) { 

    //   if ( $('#create_password').val() === $('#password_confirm').val()) {
    //     //alert('Password Good!!');
  
    //   } else {
    //     $('.password-match').fadeIn("slow");
    //     e.preventDefault(); // stops our form from submitting
    //   }
    // });

  });
});
